import axiosInstance from "./AxiosInstance";

export function getAssetSummaryReport(params = {}) {
  const isExport = params.export === true || params.export === "true";

  return axiosInstance.get("/api/reports/summary/", {
    params,
    responseType: isExport ? "blob" : "json", // 👈 if export, expect blob
  });
}

export function getAssetAllocationReport(params = {}) {
  const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/allocation/", {
    params,
    responseType: isExport ? "blob" : "json",
  });
}

export function getAssetReturnReport(params = {}) {
      const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/return/", { params ,responseType: isExport ? "blob" : "json"});
}

export function getAssetMovementReport(params = {}) {
    const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/movement/", { params , responseType: isExport ? "blob" : "json"});
}

export function getAssetDisposalReport(params = {}) {
      const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/disposal/", { params,responseType:isExport ? "blob" : "json" });
}

export function getAssetMaintenanceReport(params = {}) {
      const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/maintenance/", { params, responseType: isExport ? "blob" : "json" });
}

export function getDepreciationReport(params = {}) {
      const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/depreciation/", { params , responseType: isExport ? "blob" : "json"});
}

export function getVendorWiseReport(params = {}) {
      const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/vendor/", { params,responseType: isExport ? "blob" : "json" });
}

export function getEmployeeAssetReport(params = {}) {
      const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/employee/", { params , responseType: isExport ? "blob" : "json"});
}
export function getAssetLifecycleReport(params = {}) {
  const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/asset-lifecycle/", {
    params,
    responseType: isExport ? "blob" : "json",
  });
}
export function getAssetLocationDepartmentReport(params = {}) {
  const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/asset-location-department/", {
    params,
    responseType: isExport ? "blob" : "json",
  });
}

export function getAssetEndOfLifeReport(params = {}) {
  const isExport = params.export === true || params.export === "true";
  return axiosInstance.get("/api/reports/asset-end-of-life/", {
    params,
    responseType: isExport ? "blob" : "json",
  });
}
